var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"classes":"info-notification","position":"bottom right","animation-name":"v-fade-left","width":500}})
}
var staticRenderFns = []

export { render, staticRenderFns }